import {NewMessage} from '@/graphql/mutations/Message.graphql'
import {GetMessage} from '@/graphql/queries/Message.graphql'

export default {
  methods : {
    async newMessage(payload){
      if(typeof payload.wrap === 'undefined') payload.wrap = false;
      if(typeof payload.uxWaiting === 'undefined') payload.uxWaiting = 0;

      if(payload.wrap === true){
        payload.message = this.messageWrapper(payload.message);
      }

      return await this.postNewMessage(payload.message, payload.uxWaiting);
    },

    messageWrapper(text, tagName = 'p'){
      let wrapped = '';
      
      const separated = text.split("\n");

      for(let i = 0; i < separated.length; i++){
        wrapped += '<'+tagName+'>'+separated[i]+'</'+tagName+'>';
      }

      return wrapped;
    },

    postNewMessage(message, uxWaiting = 1000){
      return new Promise((resolve) => {
        // 以前のメッセージをすべてDisabledにします。
        this.$store.dispatch('message/disabledAllMessages');

        this.$apollo.mutate({
          mutation  : NewMessage,
          variables : {
            messageRoomId     :   this.messageRoomId,
            messageThreadId   :   this.messageThreadId,
            content           :   message,
            theme             :   'default',
            additionals       :   null,
            isWriting         :   false,
            isVisibled        :   false
          },
          update    : (store, {data: {NewMessage: {message, response}}}) => {
            store.writeQuery({ query: GetMessage, data : {
              message : message
            }});

            if(response !== null){
              store.writeQuery({ query: GetMessage, data : {
                message : response
              }});
            }
          },
        }).then(async (result) => {
          // additionalsがtagged-infomationの場合と
          // commandリクエストの場合はeditorを閉じます。
          // console.log(result.data.NewMessage.message);

          if(result.data.NewMessage.message.type !== 'command'){
            await this.$store.dispatch({
              type  : 'message/attachViewList',
              value : {
                id          : result.data.NewMessage.message.id,
                messageId   : result.data.NewMessage.message.id,
                isDisabled  : false,
              }
            });
          }else{
            this.isOpenEditorOverlay = true;
          }

          if(result.data.NewMessage.response !== null){
            if(uxWaiting !== 0){
              await this.UXWaiting(uxWaiting);
            }

            await this.$store.dispatch({
              type  : 'message/attachViewList',
              value : {
                id          : result.data.NewMessage.response.id,
                messageId   : result.data.NewMessage.response.id,
                isDisabled  : false,
              }
            });

            if(result.data.NewMessage.response.additionals === 'tagged-infomation'){
              this.isOpenEditorOverlay = true;
            }
          }
          
          resolve();
        }).catch((error) => {
          console.error(error);
          
          resolve();
        });
      });
    },
  }
}